﻿// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your Javascript code.

export const ft = function () {
	// configuration, change things here
	var config = {
		typeaheadApiAddressTemplate: 'http://localhost:5664/api/ProductSearch/UnitedStates/Retail/US/{{query}}'
	};

	// start of main code 
	function init() {

	};
	// ... more methods and other code ...

	// make init and config a public method
	return {
		init: init,
		config: config
	};
};